import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ContentWrapperComponent } from '@shared/content-wrapper/content-wrapper.component';
import { FaqsItem } from '@content/pricing/faqs/faqs.type';
import { ChevronComponent } from '@shared/chevron/chevron.component';
import { ArrowComponent } from '@shared/arrow/arrow.component';
import { TitleAndSubtitleComponent } from '@shared/title-and-subtitle/title-and-subtitle';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'companyid-faqs',
    imports: [
        ContentWrapperComponent,
        ChevronComponent,
        ArrowComponent,
        TitleAndSubtitleComponent,
        NgClass,
        RouterLink,
    ],
    templateUrl: './faqs.component.html',
    styleUrl: './faqs.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqsComponent {
    public readonly faqsContent: FaqsItem[] = [
        {
            title: $localize`:@@faqs-title-what-is:What is CompanyID.io?`,
            subtitle: $localize`:@@faqs-subtitle-what-is:CompanyID.io is a platform designed to drive business identification processes, manage company information efficiently, and integrate seamlessly with various business operations.`,
        },
        {
            title: $localize`:@@faqs-title-how-does:How does CompanyID.io work?`,
            subtitle: $localize`:@@faqs-subtitle-how-does:CompanyID.io works by providing a centralized platform where businesses can manage their identification details, track their operations, and access real-time data. It integrates with existing business systems to enhance productivity and operational efficiency.`,
        },
        {
            title: $localize`:@@faqs-title-what-features:What features does CompanyID.io offer?`,
            subtitle: $localize`:@@faqs-subtitle-what-features: CompanyID.io offers a wide range of features, including: Business tracking and reporting, Real- time data access, Efficient accounting integration, Customizable notifications and alerts, Expense tracking Inventory management, Sales and revenue tracking, Employee time tracking, Customer relationship management (CRM), Data analytics and reporting.
                `,
        },
        {
            title: $localize`:@@faqs-title-pricing:What pricing plans are available for CompanyID.io?`,
            subtitle: $localize`:@@faqs-subtitle-pricing:CompanyID.io offers flexible pricing plans to suit different business needs. You can explore our pricing plans on the Pricing page to find the best fit for your company.`,
        },
        {
            title: $localize`:@@faqs-title-free-trial:Is there a free trial available?`,
            subtitle: $localize`:@@faqs-subtitle-free-trial:Yes, CompanyID.io offers a free trial period so you can explore the platform and its features before committing to a subscription plan.`,
        },
        {
            title: $localize`:@@faqs-title-how-secure:How secure is my data on CompanyID.io?`,
            subtitle: $localize`:@@faqs-subtitle-how-secure:CompanyID.io employs industry-standard security measures to protect your data. This includes encryption, secure data centers, and regular security audits to ensure your information is safe.`,
        },
        {
            title: $localize`:@@faqs-title-handle-privacy:How does CompanyID.io handle my privacy?`,
            subtitle: $localize`:@@faqs-subtitle-handle-privacy:CompanyID.io is committed to protecting your privacy. Our Privacy Policy outlines how we collect, use, and safeguard your personal information. You can review our Privacy Policy on our website.`,
        },
        {
            title: $localize`:@@faqs-title-contact-support:How can I contact CompanyID.io support?`,
            subtitle: $localize`:@@faqs-subtitle-contact-support:You can contact CompanyID.io support through our Contact Us page. We offer multiple channels of support, including email, phone, and live chat, to assist you with any questions or issues.`,
        },
        {
            title: $localize`:@@faqs-title-find-tutorials:Where can I find tutorials or guides on how to use CompanyID.io?`,
            subtitle: $localize`:@@faqs-subtitle-find-tutorials:We provide a comprehensive set of tutorials, guides, and documentation on our website to help you get started and make the most of CompanyID.io. Visit our Help Center for more information.`,
        },
    ];

    public toggle(item: FaqsItem): void {
        item.isShown = !item.isShown;
    }
}
